import { z } from 'zod';

/**
 * Отключение JIT-компиляции схем zod в браузере.
 *
 * ⚠️ Причина — CSP, а не производительность. Чтобы решить, можно ли ускорить валидацию
 * скомпилированной функцией, zod ОДИН РАЗ пробует `new Function("")` внутри `try/catch`
 * (`zod/v4/core/util.js`, `allowsEval`). Исключение он глотает и честно переключается на
 * интерпретируемый путь — то есть формы работают, — но браузер всё равно фиксирует
 * нарушение `script-src` и печатает его в консоль.
 *
 * Симптом ровно такой, каким его увидел владелец: жмёшь «Մուտք գործել», вход проходит,
 * и в консоли появляется предупреждение CSP про eval со ссылкой на `util.js:157`.
 *
 * ⚠️ Проба не срабатывает локально и срабатывает в проде: в dev-контуре `script-src`
 * несёт `'unsafe-eval'` (его требуют Vite HMR и Swagger UI), а в проде — нет. Поэтому
 * дефект такого рода невозможно заметить на машине разработчика.
 *
 * Флаг `jitless` предусмотрен самим zod ровно для этого случая — он пропускает пробу
 * целиком. Цена: валидация идёт без скомпилированной функции. На клиенте это не имеет
 * значения — схемы здесь размером с форму входа, а в проде JIT всё равно недоступен,
 * потому что `eval` запрещён.
 *
 * ⚠️ Только для БРАУЗЕРА. На сервере CSP на собственный код не действует, схемы крупнее
 * (контракты API, валидация платёжных колбэков), и отключать там JIT значило бы платить
 * за чужую проблему.
 */
export function installZodJitless(): void {
  z.config({ jitless: true });
}
